export enum ReportHorizontalEvent {
  HeroReportsLinkClicked = "Report Horizontal Page: Reports Link Clicked",
  HeroEconPrimaryCta = "Report Horizontal Page: Econ Primary CTA Clicked (Unauthorized)",
  HeroEconSecondaryCta = "Report Horizontal Page: Econ Secondary CTA Clicked (Unauthorized)",

  IntelligenceInsightReportClicked = "Report Horizontal Page: Intelligence Insight Report Clicked",
  IntelligenceInsightLinkClicked = "Report Horizontal Page: Intelligence Insight Link Clicked",

  ScheduleTabClicked = "Report Horizontal Page: Schedule Tab Clicked",
  LatestReportClicked = "Report Horizontal Page: Latest Report Clicked",

  SearchEconAccessCTA = "Report Horizontal Page: Econ Access CTA Clicked",
}
